import "core-js/modules/web.dom-collections.iterator.js";
import React, { useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { StandardButton } from '@eika/button';
import { CheckboxField } from '../types/checkbox-field';
import { StandardInputField } from '../types/standard-input-field';
import { composeValidators, focusOnErrors, minLengthValidator, requiredField } from '../util/validator';
import ErrorMessage from './error-message';
import OverlayLoader from './overlay-loader';
const CheckboxSourceOfIncomeSection = _ref => {
  let {
    submitButtonText,
    submitCheckboxSourceOfIncome,
    onSubmit,
    submitCheckboxSourceOfIncomeSection,
    checkboxSourceOfIncomeQuestionSection,
    error
  } = _ref;
  const [loading, setLoading] = useState(false);
  const [hasTriedSubmitting, setHasTriedSubmitting] = useState(false);
  useEffect(() => {
    if (submitCheckboxSourceOfIncome.submitted) {
      setLoading(false);
      onSubmit();
    }
  }, [submitCheckboxSourceOfIncome.submitted, onSubmit]);
  const {
    questions,
    header,
    mainQuestion
  } = checkboxSourceOfIncomeQuestionSection;
  const getObjectToSubmit = values => {
    return values.sourceOfIncome.filter(value => (value === null || value === void 0 ? void 0 : value.checked) === true).map(value => {
      var _values;
      return {
        sourceId: value.sourceId,
        comment: (_values = values["comment_".concat(value.sourceId)]) !== null && _values !== void 0 ? _values : undefined
      };
    });
  };
  const submitAnswers = values => {
    if (values && Object.keys(values).length > 0) {
      setLoading(true);
      submitCheckboxSourceOfIncomeSection(getObjectToSubmit(values));
    }
    setHasTriedSubmitting(true);
  };
  const hasSelectedOptionWithCommentRequired = (values, sourceId) => {
    var _values$sourceOfIncom;
    const optionWithSourceId = questions === null || questions === void 0 ? void 0 : questions.find(option => option.sourceId === sourceId);
    const valueOfOption = values === null || values === void 0 || (_values$sourceOfIncom = values.sourceOfIncome) === null || _values$sourceOfIncom === void 0 ? void 0 : _values$sourceOfIncom.find(value => {
      return (value === null || value === void 0 ? void 0 : value.sourceId) === sourceId;
    });
    return (valueOfOption === null || valueOfOption === void 0 ? void 0 : valueOfOption.checked) && (valueOfOption === null || valueOfOption === void 0 ? void 0 : valueOfOption.sourceId) === sourceId && (optionWithSourceId === null || optionWithSourceId === void 0 ? void 0 : optionWithSourceId.requiresComment);
  };
  const noSelectedFields = values => {
    if (hasTriedSubmitting) {
      if (!(values && Object.keys(values).length > 0)) {
        return true;
      }
      if (values && values.sourceOfIncome) {
        const hasCheckedValue = values.sourceOfIncome.filter(value => value !== undefined).find(value => value.checked === true);
        return hasCheckedValue === undefined;
      }
    }
    return false;
  };
  const getErrorIfNoneSelected = values => {
    if (noSelectedFields(values)) {
      return /*#__PURE__*/React.createElement("div", {
        className: "medium-margin-top"
      }, /*#__PURE__*/React.createElement(ErrorMessage, {
        text: "Du m\xE5 velge minst ett alternativ"
      }));
    }
    return '';
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading && !error ? /*#__PURE__*/React.createElement(OverlayLoader, null) : undefined, /*#__PURE__*/React.createElement("h2", null, header), /*#__PURE__*/React.createElement(Form, {
    onSubmit: submitAnswers,
    decorators: [focusOnErrors]
  }, props => {
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: props.handleSubmit
    }, /*#__PURE__*/React.createElement("div", {
      className: "checkbox-source-of-income",
      id: "checkboxSourceOfIncome"
    }, mainQuestion && /*#__PURE__*/React.createElement("h3", null, mainQuestion), questions.map((option, index) => {
      return /*#__PURE__*/React.createElement("div", {
        className: "checkbox-field",
        key: option.sourceId
      }, /*#__PURE__*/React.createElement(CheckboxField, {
        name: "sourceOfIncome.[".concat(index, "]"),
        label: option.text,
        value: "".concat(option.sourceId),
        id: "checkbox_".concat(option.sourceId),
        onChangeOverride: event => {
          return {
            sourceId: option.sourceId,
            checked: event.target.checked
          };
        }
      }), hasSelectedOptionWithCommentRequired(props.values, option.sourceId) && /*#__PURE__*/React.createElement(StandardInputField, {
        name: "comment_".concat(option.sourceId),
        label: "Kommentar",
        validate: composeValidators(requiredField, minLengthValidator)
      }));
    })), getErrorIfNoneSelected(props.values), /*#__PURE__*/React.createElement(StandardButton, {
      className: "progress-next-button",
      type: "submit"
    }, submitButtonText));
  }));
};
export default CheckboxSourceOfIncomeSection;